<template>
  <div id="EnergyPerImport-view">
    <dv-full-screen-container>
      <div class="block-top-header">
        <div style="width:40%;">
          <top-header name="topHeader" :PageTitle="PageTitle" ActiveMenuIndex="EnergyPerImport" />
        </div>
        <div style="width:60%;">
          <el-cascader id="selectedMonth" style="font-size:22px; width:350px;"
          v-model="selectedMonth"
          :options="optionsmonth"
          :props="propsMonth"
          collapse-tags
          ></el-cascader>
          <el-select v-model="selectedBU" style="right:-100px;" class="block-top-button-field" placeholder="所有BU" @change="refreshDataOnChange()">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select class="block-top-button-field" style="right:-150px;" v-model="selectedPlant" placeholder="工厂" @change="loadRouteList()">
            <el-option
              v-for="item in PlantList"
              :key="item.PlantCode"
              :label="item.PlantName"
              :value="item.PlantCode"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="block-top-line"></div>
      <div class="main-content">
        <div class="block-top-bottom-content">
          <div class="block-top-button">
            <el-input class="block-top-button-field" v-model="CurrentEquipment" style="width:200px; margin-top:5px;" placeholder="设备">
            </el-input>
            <el-input class="block-top-button-field" v-model="CurrentPartNo" style="width:300px; margin-top:5px;" placeholder="零件号">
              <i slot="suffix" class="el-input__icon el-icon-search" style="cursor:pointer;" @click="showSearchPart()"></i>
            </el-input>
            <el-button type="primary" icon="el-icon-refresh" style="height:40px; margin-top:5px; margin-left:10px;" @click="queryData()">查 询</el-button>
            <el-button type="primary" icon="el-icon-share" style="height:40px; margin-top:5px; margin-left:10px;" @click="handleDownload()">导 出</el-button>
            <el-button type="primary" icon="el-icon-document-checked" style="height:40px; margin-top:5px; margin-left:10px;" @click="showImportDataDialog()">导 入</el-button>
          </div>
          <div class="route-content">
            <div class="block-top-content" style="height:100%;">
              <el-table
                :data="tableData"
                style="width: 100%"
                height="90%"
              >
                <el-table-column prop="EquipmentNo" label="设备编码" sortable></el-table-column>
                <el-table-column prop="EquipmentName" label="设备名称" sortable></el-table-column>
                <el-table-column prop="PartNo" label="零件号" sortable></el-table-column>
                <el-table-column prop="PartDesc" label="零件名称" sortable></el-table-column>
                <el-table-column prop="Year" label="年"></el-table-column>
                <el-table-column prop="Month" label="月"></el-table-column>
                <el-table-column prop="CycleTime" label="生产节拍" sortable></el-table-column>
                <el-table-column prop="SecCostElec" label="能耗秒单耗" sortable></el-table-column>
                <el-table-column prop="SecCostGas" label="燃气秒单耗" sortable></el-table-column>
                <el-table-column prop="CreateDate" label="导入时间" sortable></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :title="SearchPartTitle" :append-to-body="true" :visible.sync="SearchPartVisible" width="800px" height="700px">
        <span>
          <el-form :inline="true" :model="SearchPart_Query" class="demo-form-inline" size="mini">
            <el-form-item label="料号">
              <el-input v-model="SearchPart_Query.PartNo" placeholder="料号"></el-input>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="SearchPart_Query.Description" placeholder="描述"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="searchPartList()">查询</el-button>
            </el-form-item>
          </el-form>          
        </span>
        <span>
          <el-table :data="SearchPartList" stripe highlight-current-row @current-change="handleCurrentChange" height="400px">
            <el-table-column property="PartNo" label="料号" width="200"></el-table-column>
            <el-table-column property="Description" label="描述"></el-table-column>
          </el-table>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-close" @click="SearchPartVisible = false">取 消</el-button>
          <el-button type="primary" icon="el-icon-circle-check" @click="confirmSearchPart()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="ImportDataTitle" :append-to-body="true" :visible.sync="ImportDataVisible" width="90%" height="850px">
        <upload-excel-component :on-success="handleImportDataSuccess" :before-upload="beforeUpload" />
        <span>
          <el-table :data="tableData_Import" border highlight-current-row height="300px" style="width:100%;height:300px;margin-top:10px;">
            <el-table-column v-for="item of tableHeader_Import" :key="item" :prop="item" :label="item" />
          </el-table>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-close" @click="ImportDataVisible = false">取 消</el-button>
          <el-button type="primary" icon="el-icon-circle-check" @click="confirmImportData()">确 定</el-button>
        </span>
      </el-dialog>
    </dv-full-screen-container>
  </div>
</template>

<script>
import request from '@/utils/request'
import topHeader from '../TopMenu/topHeader';
import operModel from './OperModel';
import { AREA_LIST, BU_LIST } from '../mainPage/area_bu'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'

export default {
  name: 'EnergyPerImport',
  components: {
    topHeader,
    UploadExcelComponent
  },
  data() {
    return {
      PageTitle: '设备产品单耗导入',
      dialogVisible: false,
      dialogRemoveButtonDisabled: true,
      editingNodeId: '',
      options: BU_LIST,
      PlantList: [],
      RouteList: [],
      options2: AREA_LIST,
      selectedArea: '',
      selectedBU: '',
      selectedPlant: '',
      FilterNumber: '',

      tableData: [],

      optionsmonth: [],
      selectedMonth: '',

      SearchPartTitle: '选择产品',
      SearchPartVisible: false,
      SearchPartList: [],
      SearchPart_Query: {
        PartNo: '',
        Description: ''
      },
      PartCurrentRow: { },
      CurrentPartNo: '',
      CurrentPartEntity: {},

      CurrentEquipment: '',

      ImportDataVisible: false,
      tableData_Import: [],
      tableHeader_Import: []
    }
  },
  created() {
    this.optionsmonth = []
    const iNowYear = (new Date()).getFullYear()
    for (let i = iNowYear; i > iNowYear - 5; i--) {
      let itemYear = {
        label: i,
        value: i,
        children: []
      }
      for (let m = 1; m <= 12; m++) {
        let itemMonth = {
          label: m + '月',
          value: i + '-' + m
        }
        itemYear.children.push(itemMonth)
      }
      this.optionsmonth.push(itemYear)
    }
    this.optionsmonth.push({
      label: '默认月份',
      value: 0
    })
    this.optionsmonth.push({
      label: '所有数据',
      value: -1
    })
  },
  mounted() {
    const { refreshPlantList } = this

    var d = new Date()
    this.selectedMonth = [d.getFullYear(), d.getFullYear()+'-'+(d.getMonth()+1)]

    this.selectedBU = 'YFAI-AP'
    refreshPlantList()
    this.selectedPlant = 'YFJQ01'
  },
  methods: {
    refreshPlantList() {
      let selBu = ''
      if (this.selectedBU !== undefined && this.selectedBU !== '') {
        selBu = this.selectedBU
      }
      const queryArgs = { QueryAreaName: this.selectedArea, QueryBU: selBu, QueryFilterBy: 'IsUpload' }
      request({
        url: 'Kanban/PlantList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        this.PlantList = res.data.Data.PlantList
      })
    },
    queryData() {
      if (this.selectedPlant == '') {
        this.$message.error('请先选择工厂！')
        return
      }

      let postArgs = {
        PlantCode: this.selectedPlant,
        PartNo: this.CurrentPartNo,
        EquipmentNo: this.CurrentEquipment
      }
      if (this.selectedMonth != undefined && this.selectedMonth != '') {
        postArgs.Year = this.selectedMonth[0]
        if (postArgs.Year == 0) {
          postArgs.Month = 0
        } else if (this.selectedMonth.length > 1) {
          postArgs.Month = this.selectedMonth[1].split('-')[1]
        }
      }
      request({
        url: 'EnergyPer/GetAPPEnergyPerImportByMonth',
        method: 'post',
        data: postArgs
      }).then(response => {
        const res = response
        if (res.data.Data != undefined) {
          this.tableData = res.data.Data
        }
        
      })
    },
    showSearchPart() {
      this.SearchPartVisible = true
      this.SearchPartList = []
      this.PartCurrentRow = {}
    },
    searchPartList() {
      if (this.selectedPlant == '') {
        this.$message.error('请先选择工厂！')
        return
      }
      let queryArgs = {
        QueryPlantCode: this.selectedPlant,
        QueryPartNo: this.SearchPart_Query.PartNo,
        QueryPartDesc: this.SearchPart_Query.Description
      }
      request({
        url: 'Kanban/QueryPartList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        this.SearchPartList = res.data.Data
      })
    },
    handleCurrentChange(row) {
      this.PartCurrentRow = row
    },
    confirmSearchPart() {
      const { loadRouteList } = this

      if (this.PartCurrentRow == undefined || this.PartCurrentRow.PartNo == undefined) {
        this.$message.error('请先选择产品！')
        return
      }
      this.CurrentPartNo = this.PartCurrentRow.PartNo
      this.CurrentPartEntity = {}
      this.SearchPartList.forEach(x => {
        if (x.PartNo == this.CurrentPartNo) {
          this.CurrentPartEntity = x
          return
        }
      })

      this.SearchPartVisible = false
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1

      if (isLt1M) {
        return true
      }

      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    showImportDataDialog() {
      this.ImportDataVisible = true
      this.tableData_Import = []
    },
    handleImportDataSuccess({ results, header }) {
      this.tableData_Import = results
      this.tableHeader_Import = header
    },
    handleDownload() {
      this.downloadLoading = true
      import('../Export2Excel/Export2Excel').then(excel => {
        const tHeader = ['设备编码', '设备名称', '零件号', '零件名称', '年', '月', '生产节拍', '能耗秒单耗', '燃气秒单耗', '导入时间']
        const filterVal = ['EquipmentNo', 'EquipmentName', 'PartNo', 'PartDesc', 'Year', 'Month', 'CycleTime', 'SecCostElec', 'SecCostGas', 'CreateDate']
        const list = this.tableData
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
    confirmImportData() {
      const { queryData } = this

      if (this.tableData_Import.length == 0) {
        this.$message.error('没有导入的数据！')
        return
      }
      var itemData = []
      this.tableData_Import.forEach(x => {
        itemData.push({
          PlantCode: this.selectedPlant,
          EquipmentNo: x['设备编码'],
          PartNo: x['零件号'],
          Year: x['年'],
          Month: x['月'],
          CycleTime: x['生产节拍'],
          SecCostElec: x['能耗秒单耗'],
          SecCostGas: x['燃气秒单耗']
        })
      })
      var postArgs = {
        ExtValue: JSON.stringify(itemData)
      }
      request({
        url: 'EnergyPer/AddAPPEnergyPerImportList',
        method: 'post',
        data: postArgs
      }).then(response => {
        const res = response
        queryData()
        this.ImportDataVisible = false
        this.tableData_Import = []
      })
    }
  }
};
</script>
<style lang="less">
#EnergyPerImport-view {
  width: 100%;
  height: 100%;
  background-color: #1B2445;
  color: #fff;
  #dv-full-screen-container {
    //background-image: url("./img/bg.png");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .block-top-header {
    width: 100%;
    display: flex;
    background-color: #1B2445;
  }
  .block-top-line {
    //background-color: #1D2647;
    background-color: #313C5E;
    width: 100%; 
    height: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #1B2445;
  }
  .route-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-right: 30px;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-mid {
    height: 35%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 45%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content-1 {
    flex: 1;
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-button {
    height: 40px;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    background-color: #1B2445;
    height: 50px;
  }
  .block-top-button-field {
    background-color: #1B2445;
    margin-top: 15px;
    margin-left: 10px;
  }
  .block-top-button-field /deep/ .el-input__inner {
    background-color: #1B2445;
    color: #fff !important;
  }
  .block-top-model {
    height: 100px;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .el-table__body tr.current-row>td {
    color: #fff;
    background-color: #a2a4a7 !important;
  }
}

.el-select .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
  font-size: 22px;
}
.el-cascader .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
  font-size: 22px;
}
.el-cascader .el-cascader__tags .el-tag {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
}

</style>

